export const BASE_URL = "https://iclm.5techg.com/api/";
